<script setup>
import { RouterView } from 'vue-router'
import Toaster from '@/components/ui/toaster/Toaster.vue'
</script>

<template>
  <RouterView />
  <Toaster />
</template>
